import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/** Handles successful download responses in the current browser context. */
export const onDownloadSuccess = store.effects.create(
  // NOTE: Types will be inferred from feature when registered
  (feature: Feature) =>
    feature.actions.download.success.observe().pipe(
      rxjs.tap(action => {
        const { response: url } = action.data
        // S3 returns this URL with Content-Disposition: attachment, so normal
        // navigation starts a download without opening a new browser tab.
        window.location.assign(url)
      }),
      rxjs.ignoreElements(),
    ),
)
